angular.module("rjmNg.common.directives").directive "stopEvent", [
  () ->
    restrict: "A"
    link: (scope, element, attr) ->
      element.on attr.stopEvent, (e) ->
        # We may want to selectively allow propagation for things like Apply buttons
        # when we want them to close afterwards
        unless $(e.target).attr("allow-propagation")
          e.stopPropagation()
]
